export const initRadioGroup = () => {
	/**
	 *
	 * @type {NodeListOf<HTMLInputElement>}
	 */
	const radios = document.querySelectorAll('.radio-button input[type="radio"]');

	radios.forEach((radio) => {
		// Initial
		radio.parentElement.classList.toggle('checked', radio.checked);

		// For future updates
		radio.addEventListener('change', () => {
			radio.parentElement.classList.add('checked');
			// radio buttons only have the 'change' event when checked, so we have to manually clean up the other items
			const relatedRadioButtons = document.querySelectorAll(`.radio-button [name="${radio.name}"]:not(:checked)`);
			relatedRadioButtons.forEach((otherRadio) => {
				otherRadio.parentElement.classList.remove('checked');
			});
		});
	});
};
